import React from 'react';
import { gql } from '@apollo/client';
import { FunctionField, ReferenceField, Show, SimpleShowLayout, TextField } from 'react-admin';
import LinkField from 'components/LinkField';
import { scopeLabel } from 'utils/hrisMappingHelpers';

const HrisPositionMappingShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField label="ID" source="id" />
      <ReferenceField label="Company" source="company_id" reference="Company" link="show">
        <TextField source="name" />
      </ReferenceField>
      <FunctionField label="Scope" render={scopeLabel} />
      <ReferenceField
        label="Location"
        source="location_id"
        reference="Location"
        link="show"
        emptyText="-"
      >
        <TextField source="name" />
      </ReferenceField>
      <LinkField label="Position" source="position.display_name" />
      <TextField label="External ID" source="external_id" />
    </SimpleShowLayout>
  </Show>
);

HrisPositionMappingShow.query = gql`
  query hrisPositionMapping($id: Int!) {
    hrisPositionMapping(id: $id) {
      id
      company_id
      location_id
      external_id
      position_id
      position {
        id
        display_name
      }
    }
  }
`;

export default HrisPositionMappingShow;
